import React from 'react';
import { useAtom } from 'jotai';
import { Header } from 'Components/Common';
import {
  ticketAtom,
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';
import { formattingDigitCurrency, getTicketAliasFromPathname, CallApi } from 'utils';
import {
  useParams,
  useHistory
} from "react-router-dom";
import { Paper,makeStyles } from '@material-ui/core';
const { REACT_APP_TOKEN_API } = process.env;

const useStyles = makeStyles((theme) => ({
  ContainerFullScreen: {
    height: "calc(100vh - 57px)",
    width: "100%"
  },

}));

const TicketAvailable = () => {
  const classes = useStyles();
  const [ticket] = useAtom(ticketAtom);
  const history = useHistory();
  const { idPayment, type } = useParams();
  const [staticData, setStaticData] = useAtom(staticDataAtom);
  const [urlTicket, setUrlTicket] = React.useState(null);

  React.useEffect(() => {
    async function getTicket() {
      if (ticket.order.ticketAvailableToPrint) {
        const pathname = window?.location?.pathname;
        const ticketAlias = getTicketAliasFromPathname(pathname);

        let header = {
          Authorization: [REACT_APP_TOKEN_API],
          ticketAlias: ticketAlias,
        };
        if(type == "paymentLine") {
          header["paymentId"] = idPayment
        }
        const result = await CallApi("get", "ticket/demand", "", "", header);
        setUrlTicket(result[0].urlFormated)
      }
    }
    getTicket();
  }, [])
  console.log(ticket)
  console.log(idPayment)
  console.log(type)

  const currency = staticData?.currency;
  const amountFormatting = (amount) => {
    return formattingDigitCurrency(
      amount,
      currency?.countryCode,
      currency?.labelCode,
    );
  };

  const payment = ticket?.order?.payments?.done?.items.find(item => item.id == idPayment);
  if (!payment && ticket?.order?.payments?.done?.items.length) {
    const pathname = window?.location?.pathname;
    const ticketAlias = getTicketAliasFromPathname(pathname);
    history.push(`/ticket/:${ticketAlias}`)
  }
  // const handleAskTicket = async (e, email) => {
  //   e.preventDefault();
  //   if (validateEmail(email)) {
  //     const pathname = window?.location?.pathname;
  //       const ticketAlias = getTicketAliasFromPathname(pathname);
  //       const { REACT_APP_TOKEN_API } = process.env;
  //       let header = {
  //         Authorization: [REACT_APP_TOKEN_API],
  //         ticketAlias: ticketAlias,
  //         paymentId: idPayment,
  //         email: email
  //       };
  //       const result = await CallApi("get", "ticket/demand", "", "", header);
  //       if (result && result[0] && result[0].ok) {
  //         setTicketRequested(true);
  //       }
  //       console.log(result)
  //   } else {
  //     setEmailValid(false);
  //   }
  // }


  return payment ? (
    <>
    <Header
        actions={{
          prev: {
            label: `${payment.method} (${amountFormatting(payment.amount)})`,
            path: `/ticket/:${ticket.id}/requestTicket/${idPayment}`,
            icon: 'return',
          },
        }}
      ></Header>
      {urlTicket ? (
        <Paper className={classes.ContainerFullScreen}>
          <iframe src={urlTicket} style={{height: "100%", width: "100%"}}/>
        </Paper>
      ) : (
      <div>Chargement en cours</div>
      )}

    </>
  ) : null;
};

export default TicketAvailable;
